<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">话务管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">坐席通话明细</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <!-- 日期 -->
                <a-range-picker :locale="locale" @change="ondateChange" placeholder="请选择日期范围"/>
                <!-- 坐席 -->
                <a-select style="width: 120px;margin-left:12px" allowClear @change="userhandleChange" placeholder="坐席" :showArrow="show">
                    <a-select-option v-for="item in userlist" :key="item.aid" :value="item.name">
                        {{item.name}}
                    </a-select-option>
                </a-select>

                <!-- 通话时长 -->

                <div class="timesearch">
                    <a-input v-model="billsec_start"></a-input>
                    <span class="block">-</span>
                    <a-input v-model="billsec_end" placeholder="通话时长"></a-input>
                    <a-button type="primary" @click="totimeseek">搜索</a-button>
                </div>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table rowKey="id"  :pagination="pageshow" :columns="columns" :data-source="data">
    
                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <!-- <div > -->
                        <audio style="height:32px" controls="controls" slot="video" slot-scope="text" :src="text"></audio>
                    <!-- </div> -->

                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>


    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
const columns = [
    {title: 'ID',dataIndex: 'id',key: 'id',width:90},
    {title: '呼叫日期',dataIndex: 'callOutStartTime',key: 'callOutStartTime',width:120},
    {title: '坐席账号',dataIndex: 'cc_id',key: 'cc_id',width:120},
    {title: '坐席姓名',dataIndex: 'username_kf',key: 'username_kf',width:120},
    {title: '主叫',dataIndex: 'calleeNum',key: 'calleeNum',width:160},
    {title: '被叫',dataIndex: 'fwdDstNum',key: 'fwdDstNum',width:160},
    {title: '通话时长',dataIndex: 'billsec',key: 'billsec',width:120},
    {title: '录音',dataIndex: 'fileurl',key: 'fileurl',scopedSlots: { customRender: 'video' },fixed: 'right',width:220},
];
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            useroption:[{id:1,name:'坐席1'}],
            locale,

            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,
            userlist:"",

            search:"",
            billsec_start:0,
            billsec_end:""
        }
    },
  
    mounted(){
        this.fetch()
        this.getuserlist()
    },
    methods:{

        // 坐席列表
        getuserlist(){
            this.$axios.post("/api/system/adminlist",{
                pagesize:50,
                iskf:1
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.userlist=res.data.data.data
                }else{
                   this.$message.error(res.data.msg);  
                }
            })
        },

        // 日期范围
        ondateChange(e){

        },
        // 选择坐席
        userhandleChange(value){
            this.search=value
            this.fetch()
        },

         // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },
        // 通话时长
        totimeseek(){
            this.fetch()
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/kefu/calldetail',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.search,
                billsec_start:this.billsec_start,
                billsec_end:this.billsec_end
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{

                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/traffic/tellist.vue